import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock, ChevronRight, History, LogOut, Megaphone, MessageSquareWarning, Settings as Cog, UserPlus, UtensilsCrossed } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useT, Bi, TKey } from "@/lib/i18n";
import { Card, PageTitle } from "@/components/common";

const LINKS: { to: string; k: TKey; Icon: any; id: string }[] = [
  { to: "/more/join-requests", k: "join_requests", Icon: UserPlus, id: "join-requests" },
  { to: "/more/visits", k: "visits", Icon: CalendarClock, id: "visits" },
  { to: "/more/menu", k: "food_menu", Icon: UtensilsCrossed, id: "menu" },
  { to: "/more/announcements", k: "announcements", Icon: Megaphone, id: "announcements" },
  { to: "/more/complaints", k: "complaints", Icon: MessageSquareWarning, id: "complaints" },
  { to: "/more/settings", k: "settings", Icon: Cog, id: "settings" },
  { to: "/more/audit", k: "audit_log", Icon: History, id: "audit" },
];

export default function More() {
  const { t } = useT();
  const { owner, logout } = useAuth();
  return (
    <div>
      <PageTitle title={t("more")} sub={`${owner?.email || "+91 " + owner?.phone} · ${owner?.owner_code}`} />
      <div className="space-y-2.5 pg-stagger">
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} data-testid={`more-link-${l.id}`} className="block">
            <Card className="p-4 flex items-center gap-3 pg-tap hover:border-emerald-300">
              <div className="h-11 w-11 rounded-xl bg-emerald-50 text-emerald-700 grid place-items-center"><l.Icon className="h-5 w-5" /></div>
              <Bi k={l.k} className="flex-1 font-semibold" />
              <ChevronRight className="h-4 w-4 text-slate-400" />
            </Card>
          </Link>
        ))}
        <button data-testid="more-logout-btn" onClick={logout} className="w-full h-14 rounded-2xl border border-slate-200 bg-white font-semibold text-rose-600 flex items-center justify-center gap-2 pg-tap">
          <LogOut className="h-4 w-4" />{t("logout")}
        </button>
      </div>
    </div>
  );
}

export function BackLink() {
  const { t } = useT();
  return <Link to="/more" data-testid="back-to-more" className="inline-flex h-10 items-center text-sm font-semibold text-slate-600 mb-1">← {t("more")}</Link>;
}
